import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, CheckCircle2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CompletarCadastro = () => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || "";
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setErro("");
    if (senha.length < 8) {
      setErro("A senha precisa ter pelo menos 8 caracteres.");
      return;
    }
    if (senha !== confirmarSenha) {
      setErro("As senhas nao coincidem.");
      return;
    }
    setCarregando(true);
    try {
      const resp = await fetch(`${BACKEND_URL}/api/hotmart/completar-cadastro`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, senha }),
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error(data.detail || "Erro ao completar cadastro.");
      localStorage.setItem("access_token", data.access_token);
      setSucesso(true);
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } catch (error) {
      setErro(error.message);
    } finally {
      setCarregando(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-[100dvh] bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 flex items-center justify-center px-4">
        <Card className="bg-gray-900/80 border-gray-800 p-6 max-w-md text-center">
          <p className="text-red-400">Link invalido. Verifique o link enviado por e-mail.</p>
        </Card>
      </div>
    );
  }

  if (sucesso) {
    return (
      <div className="min-h-[100dvh] bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 flex items-center justify-center px-4">
        <Card className="bg-gray-900/80 border-gray-800 p-6 max-w-md text-center">
          <CheckCircle2 className="w-12 h-12 text-green-400 mx-auto mb-3" />
          <h2 className="text-white text-lg font-semibold mb-1">Cadastro concluido!</h2>
          <p className="text-gray-400 text-sm">Redirecionando para o sistema...</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-[100dvh] bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 flex items-center justify-center px-4 py-6 overflow-y-auto">
      <Card className="bg-gray-900/80 border-gray-800 p-6 max-w-md w-full">
        <h1 className="text-2xl font-bold text-white mb-1">Bem-vindo ao ClickHub!</h1>
        <p className="text-gray-400 text-sm mb-5">Seu pagamento foi confirmado. Crie sua senha para acessar o sistema.</p>
        <form onSubmit={enviar} className="space-y-4">
          <div>
            <label className="text-gray-300 text-sm mb-1 block">Nova senha</label>
            <Input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              className="bg-gray-800 border-gray-700 text-white"
              placeholder="Minimo 8 caracteres"
            />
          </div>
          <div>
            <label className="text-gray-300 text-sm mb-1 block">Confirmar senha</label>
            <Input
              type="password"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              className="bg-gray-800 border-gray-700 text-white"
              placeholder="Repita a senha"
            />
          </div>
          {erro && <p className="text-red-400 text-sm">{erro}</p>}
          <Button type="submit" disabled={carregando} className="w-full bg-orange-500 hover:bg-orange-600">
            {carregando ? <Loader2 className="w-4 h-4 animate-spin" /> : "Criar minha conta"}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default CompletarCadastro;
